import { api } from '@/api';
import { MedicalSystemRtSystemDto } from '@/api/generator';
import { useActionWithConfirmation } from '@/components/confirmationModals/useActionWithConfirmation';
import { I18nKey } from '@/utils/typings';
import { useTranslation } from 'i18next-vue';

export function useDeleteMedicalSystemWithConfirmation() {
  return useActionWithConfirmation({
    confirmedAction: async (id: string) =>
      await api.medicalSystemsApi.deleteMedicalSystemRtSystem({
        id,
      }),
  });
}

export function getMedicalSystemSubtitle(medicalSystem: MedicalSystemRtSystemDto) {
  const { t } = useTranslation();
  return [
    t(`RtSystemCategoryEnum.${medicalSystem.category}` as I18nKey),
    t(`MedicalSystemSubCategoryEnum.${medicalSystem.subCategory}` as I18nKey),
    t(`RtSystemManufacturerEnum.${medicalSystem.manufacturer}` as I18nKey),
    t(`RtSystemModelEnum.${medicalSystem.model}` as I18nKey),
    medicalSystem.subModel && t(`MedicalSystemSubModelEnum.${medicalSystem.subModel}` as I18nKey),
  ]
    .filter(Boolean)
    .join(' | ');
}
